import createCustomElementWrapper from './utils/createCustomElementWrapper';
export var KatTab = createCustomElementWrapper('kat-tab', 'KatTab', {
    'overflowTabSelected': 'overflow-tab-selected',
    'secondaryLabel': 'secondary-label',
    'tabId': 'tab-id',
    'trendPolarity': 'trend-polarity',
}, {}, [
    'label',
    'status',
]);
